import React from 'react';
import { Shimmer, ShimmerAvatar, ShimmerTypography } from '@pitchero/react-ui';

const FixtureLoadingStateRow = () => (
  <>
    <ShimmerTypography width="80%" style={{ maxWidth: '147px' }} preset="name" />
    <ShimmerAvatar size={32} style={{ justifySelf: 'center' }} />
    <Shimmer height="32px" width="45px" radius="5px" />
    <ShimmerAvatar size={32} style={{ justifySelf: 'center' }} />
    <ShimmerTypography width="80%" style={{ maxWidth: '147px' }} preset="name" />
  </>
);

export default FixtureLoadingStateRow;
